import React, { useState } from 'react';
import Context from './index';


const ProductProvider = (props) => {
    const [productItem, setProductItem] = useState([]);
    const symbol = '$';
    // productItem can be populated through other mechanisms (real API / user actions)

    return (
        <Context.Provider value={{ ...props, productItem, symbol }}>
            {props.children}
        </Context.Provider>
    );
};

export default ProductProvider;
